import {
  AdSpendChip as SharedAdSpendChip,
  AdSpendChipProps as SharedAdSpendChipProps,
} from '@features/campaigns/components/AdSpendChip';
import { useCurrentAdSpend } from '../hooks/useAdSpend';

export const AdSpendChip = (props: Omit<SharedAdSpendChipProps, 'adSpend'>) => {
  const { adSpend } = useCurrentAdSpend();

  return <SharedAdSpendChip {...props} adSpend={adSpend} />;
};
